import { post } from 'lib/request';

export const postUploadImage = async ({ file }) => {
  const formData = new FormData();

  formData.append('file', file);

  return post('/image', {
    body: formData,
    stringify: false,
    toSnake: false,
    headers: { 'Content-Type': null },
  });
};
